import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Col, Container, Row} from 'react-bootstrap';
import EditBrandForm from './brand-edit-form';
import BackLink from '../../../../common/back-link/index';
import PageTitle from '../../../../common/page-title/index';
import {getAbmCodes, getBrand} from '../../../../../actions/brands';
import {getCategories} from '../../../../../actions/categories';
import {initialStates} from '../../../../../initialStates';

class EditBrand extends Component {
  UNSAFE_componentWillMount() {
    const id = +this.props.match.params.id;
    if (id) {
      this.props.dispatch(getBrand(id));
    }
    this.props.dispatch(getCategories('', 'INITIALIZE_ADD_BRAND'));
    this.props.dispatch(getAbmCodes());
  }

  componentWillUnmount() {
    this.props.dispatch(actions.load('deep.admin_brand', initialStates.admin_brand));
    this.props.dispatch({type: 'CLEAR_EDIT_BRAND'});
  }

  render() {
    return (
      <Container fluid className="product-brands">
        <Row>
          <Col lg={12}>
            <BackLink href="/admin/brands"/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              Add/Edit brand
            </PageTitle>
            <EditBrandForm brand={this.props.brand}/>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  brand: state.brands.brand,
  fetched: state.brands.fetched,
  fetching: state.brands.fetching,
});

export default connect(mapStateToProps)(EditBrand);
